import { mapCollection } from '../../utils/collection.utils';
import { AccumulativeReport } from '../accumulative-report';

export class AccumulativeReportBuilder {
  static fromJson(json) {
    return (json)
      ? new AccumulativeReport(
        json.answerAVG,
        json.categoryTitle
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(AccumulativeReportBuilder.fromJson, list) : [];
  }
}
